export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          移动观影
        </h2>
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[960px] mx-auto">
          <div className="flex-shrink-0 w-full max-w-[280px]">
            <div className="relative mx-auto w-[240px]">
              <img
                src="https://readdy.ai/api/search-image?query=smartphone%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%20in%20warm%20coral%20and%20dark%20theme%2C%20minimalist%20mobile%20UI%2C%20floating%20phone%20on%20clean%20light%20background%2C%20elegant%20app%20design%2C%20soft%20shadow%2C%20modern%20streaming%20platform%20mockup&width=600&height=1000&seq=app-mobile-2026&orientation=portrait"
                alt="桃花影院移动端观影界面"
                className="w-full rounded-2xl"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              随时随地 · 畅享高清观影
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              桃花影院完美适配手机与平板设备，无需下载任何应用，打开浏览器即可享受流畅高清的观影体验。支持全屏播放、倍速调节、记忆播放进度，让您的移动观影更加便捷舒适。无论是在通勤路上还是休闲时光，海量免费影视资源随时陪伴。
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              {['高清流畅', '多倍速播放', '播放记忆', '免下载安装'].map((tag) => (
                <span
                  key={tag}
                  className="whitespace-nowrap px-3 py-1.5 bg-background-50 border border-background-200 rounded-full text-xs font-medium text-foreground-600"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}